import { useMemo } from 'react';
import buildPipelineJson from './buildPipelineJson';

import { ERRORS } from './ERRORS';

export default function usePipelineJson({
  pipelineIntegrations,
  cliManagedIntegrations,
  author,
  writekey,
  pipelineConfiguration,
  setErrorMsg,
}) {
  return useMemo(() => {
    try {
      return buildPipelineJson({
        pipelineIntegrations,
        cliManagedIntegrations,
        author,
        writeKey: writekey,
        pipelineConfiguration,
      });
    } catch (error) {
      setErrorMsg({
        title: ERRORS.DIFF_ERROR,
        message: error.toString(),
      });
      return {};
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pipelineIntegrations, cliManagedIntegrations, author, writekey, pipelineConfiguration]);
}
